import s from './home.module.css';

const steps = [
  { title: 'Intake',  body: "Tell ELARIA what's happening. Two to ten minutes. She structures your matter, identifies jurisdiction, deadlines, and the legal questions in play." },
  { title: 'Triage',  body: 'ELARIA scopes the engagement, estimates effort, and proposes a limited-scope plan. You see a flat-fee quote before any attorney is engaged.' },
  { title: 'Engage',  body: "The firm's attorney reviews the scoped intake, confirms or adjusts the scope and fee, and signs the limited-scope engagement. Every matter stays with its attorney of record — nothing is routed or reassigned." },
  { title: 'Deliver', body: 'Your attorney files, argues, or advises. ELARIA prepares drafts, tracks deadlines, and keeps you informed in plain English. You see every document, every cite, every audit trail.' },
];

export default function HowItWorks() {
  return (
    <section id="how">
      <div className="container">
        <span className={s.sectionLabel}>How it works</span>
        <h2 className={s.sectionTitle}>Intake to resolution &mdash; in four steps.</h2>
        <p className={s.sectionLead}>
          From the first message to the last filing, the process is structured, transparent, and priced up
          front. No surprise invoices. No hour-by-hour anxiety.
        </p>
        <div className={s.steps}>
          {steps.map((st, i) => (
            <div key={i} className={s.step}>
              <div className={s.stepTitle}>{st.title}</div>
              <p className={s.stepBody}>{st.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
